import { render, staticRenderFns } from "./siteFooter.vue?vue&type=template&id=1d0546fc"
import script from "./siteFooter.vue?vue&type=script&lang=js"
export * from "./siteFooter.vue?vue&type=script&lang=js"
import style0 from "./siteFooter.vue?vue&type=style&index=0&id=1d0546fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports